module.exports = __webpack_public_path__ + "f8ba36736248a5f9490b313ceada3573.png";